"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.custom-branding.disabled': '自定义品牌功能在您当前的计划中不可用。',
};
